var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTableSourceYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 11,
    viewBox: "0 0 17 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4667 1.06C15.0285 0.288 14.553 0.146 13.5848 0.092C12.6177 0.027 10.1856 0 8.07861 0C5.96759 0 3.53452 0.027 2.56836 0.091C1.60219 0.146 1.12567 0.287 0.683481 1.06C0.232202 1.831 0 3.159 0 5.497C0 5.499 0 5.5 0 5.5C0 5.502 0 5.503 0 5.503V5.505C0 7.833 0.232202 9.171 0.683481 9.934C1.12567 10.706 1.60118 10.846 2.56735 10.911C3.53452 10.967 5.96759 11 8.07861 11C10.1856 11 12.6177 10.967 13.5858 10.912C14.554 10.847 15.0295 10.707 15.4677 9.935C15.923 9.172 16.1532 7.834 16.1532 5.506C16.1532 5.506 16.1532 5.503 16.1532 5.501C16.1532 5.501 16.1532 5.499 16.1532 5.498C16.1532 3.159 15.923 1.831 15.4667 1.06Z",
    fill: "#F44336"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05469 9V3L11.1026 6L6.05469 9Z",
    fill: "#FAFAFA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableSourceYoutube);
export default __webpack_public_path__ + "static/media/table-source-youtube.c55cd644aa1aafca85cf3ef55464bf09.svg";
export { ForwardRef as ReactComponent };